import { useState } from 'react';

export function HelpIcon({ text, id }) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="help-wrapper">
      <button type="button" className="help-btn" aria-label="Help information"
        onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)} onBlur={() => setVisible(false)}
        onClick={e => { e.preventDefault(); setVisible(v => !v); }}>?</button>
      {visible && (
        <span id={`${id}-tip`} role="tooltip" className="help-tip">{text}</span>
      )}
    </span>
  );
}
